import { useSelector } from "react-redux";
import { sha256 } from "../../networking/security";
import { getFingerPrint } from "../utilityFunctions";
import platform from "platform";

export const useV1AuditLog = () => {
    const stateUsername = useSelector(
        (state) => state.accountState?.singleSmeAccount?.signatory?.email,
    );
    const ipAddress = useSelector((state) => state.accountState?.localIpAddress.ip);
    const sessionUsername = sessionStorage.getItem("kudaUserEmail");
    const appVersion = window.navigator.appVersion;
    const macAd = getFingerPrint();
    const newMacAd = sha256(`${macAd}${stateUsername ? stateUsername : sessionUsername}`);
    const auditLogData = {
        USERNAME: stateUsername ? stateUsername : sessionUsername,
        SYSTEMIPADDRESS: ipAddress,
        SYSTEMMACADDRESS: newMacAd.slice(-40),
        SYSTEMNAME: `${appVersion.split(")")[0]})`,
        SUBJECTIDENTIFIER: stateUsername ? stateUsername : sessionUsername,
    };
    return auditLogData;
};

export const useAuditLog = () => {
    const stateUsername = useSelector(
        (state) => state.accountState?.singleSmeAccount?.signatory?.email,
    );
    const ipAddress = useSelector((state) => state.accountState?.localIpAddress.ip);
    const sessionUsername = sessionStorage.getItem("kudaUserEmail");
    const time = new Date();
    const auditLogData = {
        username: stateUsername ? stateUsername : sessionUsername,
        ipAddress: ipAddress,
        time: time.toISOString(),
    };
    return auditLogData;
};

export const useOnboardingAuditLog = () => {
    const macAd = getFingerPrint();
    const stateUsername = useSelector(
        (state) => state.accountState?.singleSmeAccount?.signatory?.email,
    );
    const sessionUsername = sessionStorage.getItem("kudaUserEmail");
    const newMacAd = sha256(`${macAd}${stateUsername ? stateUsername : sessionUsername}`);
    let location = sessionStorage.getItem("location");
    let ipAddress = sessionStorage.getItem("kudaClientIpAddress");
    const deviceName = platform.description;
    const time = new Date();

    const auditLogData = {
        apiVersion: "2",
        localTime: time.toISOString(),
        longitudeLatitude:
            typeof location !== "undefined" ? location : ipAddress ? ipAddress : null,
        macAddress: newMacAd.slice(-40),
        operatingSystem: 3,
        operatingSystemVersion: deviceName,
    };

    return auditLogData;
};
